module.exports = __webpack_public_path__ + "img/tianqi1.9a9aafc6.png";